import { SvgIcon, SvgIconProps } from "@mui/material";

export const Mail = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="33"
      height="23"
      viewBox="0 0 33 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Group 15">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M21.1955 12.8584L18.4559 15.6073C17.3449 16.7221 15.3902 16.7462 14.2552 15.6073L11.5154 12.8584L1.67554 22.7303C2.04181 22.8996 2.44565 23.0007 2.87499 23.0007H29.8361C30.2654 23.0007 30.6691 22.8998 31.0353 22.7303L21.1955 12.8584Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path
              id="Vector_2"
              d="M29.8361 0H2.87498C2.44565 0 2.04181 0.101072 1.67566 0.270442L12.1903 10.82C12.191 10.8207 12.1918 10.8208 12.1925 10.8215C12.1932 10.8222 12.1934 10.8232 12.1934 10.8232L15.6123 14.2534C15.9754 14.6165 16.7358 14.6165 17.0989 14.2534L20.5171 10.8237C20.5171 10.8237 20.518 10.8222 20.5187 10.8215C20.5187 10.8215 20.5202 10.8207 20.5209 10.82L31.0353 0.270378C30.6691 0.100945 30.2654 0 29.8361 0Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path
              id="Vector_3"
              d="M0.305772 1.61035C0.116278 1.99356 0 2.41893 0 2.87459V20.1246C0 20.5802 0.11615 21.0056 0.305708 21.3888L10.1627 11.4999L0.305772 1.61035Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_7">
          <g id="Group_8">
            <path
              id="Vector_4"
              d="M32.4054 1.61035L22.5486 11.5L32.4054 21.3891C32.5949 21.0059 32.7112 20.5805 32.7112 20.1247V2.87471C32.7112 2.41893 32.5949 1.99356 32.4054 1.61035Z"
              fill="white"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
